import React from "react";
import { Card } from "reactstrap";

const RecommendationBanner = ({ title = "الإجراء المقترح:", message }) => {
  return (
    <Card className="shadow-sm border-0 rounded-4 p-3 bg-light mb-4" style={{ direction: "rtl" }}>
      <div className="d-flex align-items-center gap-3">
        <div
          className="rounded-circle d-flex align-items-center justify-content-center text-white flex-shrink-0"
          style={{
            width: "42px",
            height: "42px",
            backgroundColor: "#2563eb",
          }}
        >
          <i className="ri-star-fill" style={{ fontSize: "20px" }}></i>
        </div>
        <div>
          <div
            className="fw-bold mb-1"
            style={{ fontSize: "16px", color: "#1e40af" }}
          >
            {title}
          </div>
          <div style={{ fontSize: "14px", color: "#1e293b" }}>
            {message}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default RecommendationBanner;
